import { ActionType, createReducer } from 'typesafe-actions';
import { notificationsActions } from './actions';
import { Notification } from './types';

export const notificationsReducer = createReducer<
  { [key: string]: Notification },
  ActionType<typeof notificationsActions>
>({}).handleAction([notificationsActions.setNotificationsMap], (state, action) => ({ ...state, ...action.payload }));
